module.exports = __webpack_public_path__ + "static/media/toronto-raptors.02daf42f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/data/svg/toronto-raptors.svg
// module id = 238
// module chunks = 0